import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

const StyledCatchword = styled.span`
  ${({
    theme: {
      typography: {
        headings: {
          xsmall: { bundledCSS: xsmallHeading },
        },
      },
      colors: { staticNeutral400 },
      spacing: { spacing8 },
    },
  }) => {
    return css`
      ${xsmallHeading};
      color: ${staticNeutral400};
      margin-right: ${spacing8};
    `
  }}
`

const Catchword: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledCatchword>{children}</StyledCatchword>

export default Catchword
